<template>
  <div class="select">
     <div class="exam-result-wrap" >
          <div class="exam-cell" >
              <div class="cell-tit">
                  <span>{{$t('tureOrFalse2')}}</span>
                  <audio-btn class="exam-audio"></audio-btn>
                  <p v-html="cur_data.chapter_content.quiz_title"></p>
                  <!-- 图片查看 -->
                  <div class="img-wrap" v-if="cur_data.file_path ? cur_data.file_path.length>0 : false">
                    <div v-for="(item, index) in cur_data.file_path" :key="index" class="img-list" @click="lookBgImg(item)">
                        <img :src="item"/>
                        <img src="@/assets/img/h5/img_fd.png" class="enlargement"/>
                    </div>
                  </div>
              </div>
              <div class="cell-con">
                <div class="option" v-for='(item,index) in cur_data.chapter_content.dry' :key="item.id">
                    <div class="option-tit" v-if="index==0"><span>{{$t('wrong')}}</span><span>{{$t('correct')}}</span></div>
                    <!-- 未提交 -->
                    <div  class="option-cell submit" v-show="!cur_data.answerShow">
                        <!-- <span>{{parseInt(index+1)}}、{{item.option[0].content}}</span> -->
                        <span>{{parseInt(index+1)}}、{{item.content}}</span>
                        <span @click='choseTrue(item,1)' :class="{isChosed:item.isChosed==1}" ><i></i></span> <!-- 正确框 -->
                        <span @click='choseTrue(item,2)' :class="{isChosed:item.isChosed==2}" ><i></i></span> <!-- 错误框 -->
                    </div>
                    <!-- 已提交 -->
                    <div class="submited"  v-show="cur_data.answerShow" style="padding: .1rem 0;">
                        <div class="option-cell" :class="{right_r:item.isRight==1,warning_r:item.isRight==3,right_w:item.isRight==2,warning_w:item.isRight==4}">
                            <!-- <span>{{parseInt(index)+1}}、{{item.option[0].content}}</span> -->
                            <span>{{parseInt(index)+1}}、{{item.content}}</span>
                            <span ><i></i></span> <!-- 正确框 -->
                            <span ><i></i></span> <!--  错误框 -->
                        </div>
                        <div class="answer_fx" v-if="item.analysis">
                                <span>参</span><p v-html="item.analysis"></p>
                        </div>
                    </div>
                </div>
                 <div class="feedback" v-show="cur_data.answerShow">
                        <span>{{$t('answerFeedback')}}</span>
                        <div class="con" v-html="cur_data.chapter_content.feedback.right"></div>
                  </div>
              </div>
          </div>
     </div>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" >
            <v-bg-img :imgSrc="imgActive" v-if="imgActive" @closeImg="closeImg"></v-bg-img>
        </transition>
  </div>
</template>

<script>
import vBgImg from 'components/H5/bgImg.vue'
import mixins from 'components/H5/mixins/compon.js'
import audioBtn from 'components/H5/audioBtn'

export default {
  name: '',
  mixins: [mixins],
  data () {
    return {
      submitState: true,
      imgActive: null,
      answerShow: true // 未提交
    }
  },
  computed: {
    cur_data () {
      return this.$store.state.cur_data
    },
    next_data () {
      return this.$store.state.next_data
    }
  },
  created () {
    this.getChapterAnswer()
  },
  mounted () {
    this.$nextTick(() => {
      this.$store.commit('setAudioSrc', this.cur_data.audio_path || null)
      this.$store.commit('setAutoPlayer', !this.cur_data.answerShow)
    })
  },
  methods: {
    choseTrue (option, n) {
      this.$set(option, 'isChosed', n)
    },
    submit () {
      let canSubmit = false
      let optionDatas = this.cur_data.chapter_content.dry
      // console.log(optionDatas )
      for (let i = 0; i < optionDatas.length; i++) {
        let optionData = optionDatas[i]
        if (!optionData.isChosed) {
          canSubmit = false
          this.$layer.msg(this.$t('finishedSubmit'))
          return
        } else {
          canSubmit = true
        }
        if (canSubmit) {
          if (optionData.isChosed == 1) {
            // debugger
            if (optionData.option[0].answer == 1) {
              this.$set(optionData, 'isRight', 1) // isRight:1 ‘正确’为正确
            } else {
              this.$set(optionData, 'isRight', 2) // isRight:2 ‘正确’为错误
            }
          } else {
            if (optionData.option[0].answer == 0) {
              this.$set(optionData, 'isRight', 3) // isRight:3‘错误’为正确
            } else {
              this.$set(optionData, 'isRight', 4) // isRight:4 ‘错误’为错误
            }
          }
          if (i == optionDatas.length - 1) {
            this.cur_data.answerShow = true
            this.setChaperAnswer()
          }
        }
      }
    },
    // 查看大图
    lookBgImg (src) {
      this.imgActive = src
    },
    // 关闭图片
    closeImg () {
      this.imgActive = null
    }
  },
  components: {
    vBgImg,
    audioBtn
  }
}
</script>

<style lang="less" scoped>
.select {
    font-size: .26rem;
    .exam-result-wrap {

    .exam-cell{
      width: 100%;
      min-height:1.9rem;
      background-color: #fff;
      color: #252631;
      box-sizing: border-box;
      padding: .3rem 0 .15rem;
      .cell-tit {
        font-size: .3rem;
        .exam-audio{
          display: inline-block;
        }
        .img-wrap{
          margin-top: .3rem;
        }
        span {
          display: inline-block;
          color: #005587;
          font-size: .24rem;
          vertical-align: top;
          &:nth-of-type(1){
            text-align: center;
            color: #005587;
            border-radius: 4px;
            border: .02rem solid #005587;
            position: relative;
            padding:.015rem .1rem;
            box-sizing: border-box;
            &:after {
              width: .1rem;
              height: .1rem;
              background: white;
              position: absolute;
              bottom: -.07rem;
              left: .2rem;
              content: "";
              z-index: 1;
              transform: rotate(45deg);
              border-right: .02rem solid #005587;
              border-bottom: .02rem solid #005587;
            }
          }
          &:nth-of-type(2){
            margin-left: .2rem;
          }
        }
       p {
           margin-top:.2rem;
       }
      }
      .cell-con {
        color: #252631;
        font-size:.28rem;
        padding-bottom: .25rem;
        .mini-img{
          position: relative;
          width: 1.2rem;
          height: 1rem;
          display: inline-block;
          margin-top: .3rem;
          img {
            position: absolute;
            display: inline-block;
            width: 1.2rem;
            height: 1rem;
            margin: 0 .2rem .2rem 0;
          }
          .fd {
            position: absolute;
            width: 1.2rem;
            height: 1rem;
            left: 0;
            top: 0;
            margin: 0 .2rem .2rem 0;
            background: url('../../../assets/img/h5/img_fd.png') no-repeat center;
            -webkit-background-size:50%;
            background-size:50%;
          }

        }
        .big-img {
          position: fixed;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index:10;
          background-color: rgba(0,0,0,.2);
          img {
            position: absolute;
            width: 100%;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        p {
          overflow: hidden;
          -webkit-box-orient:vertical;
        }
         .feedback {
              width:100%;
              border-top:1px solid #D9DDDE;
              margin-top:.4rem;
              span {
                  display: inline-block;
                  color:@basic-color;
                  font-size:.3rem;
                  margin: .3rem 0 .2rem;
                  font-weight:bold;
              }
          }
        .option {
        //   border-top:1px solid #D9DDDE;
          // padding: .1rem 0  .3rem;
          margin-top: .3rem;
          .option-tit {
              height: 0.5rem;
              span {
                display: inline-block;
                // width: 1rem;
                width: .88rem;
                float: right;
                text-align: center;
                color: @basic-color;
              }
          }
          .option-cell {
            width: 100%;
            min-height:1rem;
            border:1px solid #D9DDDE;
            // position: relative;
            margin-top: .2rem;
            border-radius:.05rem;
            box-sizing: border-box;
            display:flex;
            justify-content: space-between;
            span {
              // display: inline-block;
              // width: 4rem;
              width:68%;
              vertical-align: middle;
              min-height:1rem;
              &:nth-of-type(1){
                flex: 1;
                color: #666;
                padding: .3rem .2rem 0.3rem .2rem;
                font-size:.26rem;
                min-height:1rem;
                box-sizing: border-box;
                text-align:justify;
              }
              &:nth-of-type(2),&:nth-of-type(3){
                text-align: center;
                font-weight: bold;
                // width: 1rem;
                width:.88rem;
                border-left:1px solid #D9DDDE;
                // float:right;
                position:relative;
                i {
                  display: block;
                  width: .4rem;
                  height: .4rem;
                  border-radius:50%;
                  border:1px solid #D9DDDE;
                  position: absolute;
                  right: 50%;
                  top: 50%;
                  margin-top: -.2rem;
                  margin-right: -.2rem;
                  box-sizing:border-box;
                }
                 &.isChosed {
                    i {
                    background: url('../../../assets/img/h5/chose.png') no-repeat center / contain;
                    border:none;
                  }
                }
              }
            }
            &.right_r {
              border:2px solid rgba(74, 168, 84, 1);
              span {
                &:nth-of-type(2){
                  i {
                    background: url('../../../assets/img/h5/true.png') no-repeat center;
                  }
                  border-left:2px solid rgba(74, 168, 84, 1);
                }
                &:nth-of-type(3){
                  border-left:2px solid rgba(74, 168, 84, 1);
                }
              }
            }
             &.right_w {
              border:2px solid #F75D5D;
              span {
                &:nth-of-type(2){
                  i {
                    background: url('../../../assets/img/h5/false.png') no-repeat center;
                  }
                  border-left:2px solid #F75D5D;
                }
                 &:nth-of-type(3){
                  i {
                    background: url('../../../assets/img/h5/choose-true.png') no-repeat center;
                  }
                }
                &:nth-of-type(3){
                  border-left:2px solid #F75D5D;
                }
              }
            }
            &.warning_r {
              border:2px solid rgba(74, 168, 84, 1);
              span {
                &:nth-of-type(3){
                  i {
                    background: url('../../../assets/img/h5/true.png') no-repeat center;
                  }
                  border-left:2px solid rgba(74, 168, 84, 1);
                }
                &:nth-of-type(2){
                  border-left:2px solid rgba(74, 168, 84, 1);
                }
              }
            }
             &.warning_w {
              border:2px solid #F75D5D;
              span {
                &:nth-of-type(3){
                  i {
                    background: url('../../../assets/img/h5/false.png') no-repeat center;
                  }
                }
                 &:nth-of-type(2){
                  i {
                    background: url('../../../assets/img/h5/choose-true.png') no-repeat center;
                  }
                  border-left:2px solid #F75D5D;
                }
                &:nth-of-type(3){
                  border-left:2px solid #F75D5D;
                }
              }
            }
            &.isChosed {
              border:3px solid #005587;
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/chose.png') no-repeat center / contain;
                    border:none;
                  }
                }
                &:nth-of-type(2){
                  border-left:3px solid #005587;
                }
              }
            }
          }
        }
        .option_wd {
          .option_a {
            width: 100%;
            background:rgba(247,247,247,1);
            border:1px solid rgba(217,221,222,1);
            font-size:.2rem;
            color: #666;
            padding: .2rem;
            margin: .2rem 0;
          }
          .option_e {
            border:1px solid #005587;
            width: 100%;
            height:auto;
            position: relative;
            border-radius: 3px;
            padding: .2rem;
            background-color: #EEF5FC;
            &:after{
              content: '';
              position: absolute;
              left: .4rem;
              top: -.11rem;
              width: .2rem;
              height: .2rem;
              -webkit-transform: rotate(45deg);
              transform: rotate(45deg);
              border:1px solid #005587;
              border-radius: 1px;
              background-color: #EEF5FC;
              border-right: none;
              border-bottom: none;
            }
            h6 {
              color: #005587;
              font-size:.24rem;
              font-weight: bold;
            }
          }
        }
        .option-e {
          margin-top: .3rem;
          font-size:.28rem;
          font-weight: bold;
          span {
            &.right {
              color: #252631;
            }
            &.false {
              color: #F75D5D;
            }

          }
          i {
            display: inline-block;
            &.false {
              color: #F75D5D;
            }
              &.right {
                color: #4AA854;
              }

            }
        }
        .unfold {
          color: #005587;
          font-size:.24rem;
          margin: .1rem;
          text-align: right;
          font-weight: bold;
          img {
            float: right;
            width: .1rem;
            height: .06rem;
            text-align: right;
            margin:.16rem 0 0 .1rem;
            transition: all 1s;
            &.up {
              transform: rotate(180deg);
            }
          }
        }

      }
    }
  }
}
</style>
